import { render, staticRenderFns } from "./InstallSkill.vue?vue&type=template&id=0c7c27e8&scoped=true&"
import script from "./InstallSkill.vue?vue&type=script&lang=js&"
export * from "./InstallSkill.vue?vue&type=script&lang=js&"
import style0 from "./InstallSkill.vue?vue&type=style&index=0&id=0c7c27e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7c27e8",
  null
  
)

export default component.exports